import axios from 'axios';

export default {
  isQuizComplete
};

export function isQuizComplete(params) {
  return axios.get('/api/quiz/isQuizComplete', { params });
}
